// extracted by mini-css-extract-plugin
export default {"link":"header-link_link__8qFtW"};